module.exports = __webpack_public_path__ + "img/flag-en@2x.c5337c1d.png";